import {
  createWithdrawExplorerAsync,
  createWithdrawExplorerVerificationEmailAsync,
  createWithdrawPartnerAsync,
  createWithdrawExplorerUSDTAsync,
  createWithdrawFlipmeAsync,
  createWithdrawMLPPartnerAsync
} from './Withdraw.requests';

import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  changeAvailableBalance,
  changeAvailableMLPBalance
} from '../../../slices/earnings-slice';
import { Dispatch, SetStateAction } from 'react';
import { ErrorToast, SuccessToast } from '../../../components';

import { WithdrawAvailability } from '../../Portfolio/Portfolio.types';
import { NetworkType } from '../../../types/types';
import { getMyHubsSummary } from '../../Portfolio/Portfolio.actions';

export const createWithdrawExplorer = createAsyncThunk(
  'createWithdrawExplorer',
  async (
    {
      amount,
      userWalletId,
      setStep,
      emailCode,
      twoFACode,
      setAmount,
      withdrawAvailabilitySteps
    }: {
      amount: number;
      userWalletId: number;
      setStep: Dispatch<SetStateAction<number>>;
      emailCode: string;
      twoFACode: string;
      setAmount: Dispatch<SetStateAction<string>>;
      withdrawAvailabilitySteps: number;
    },
    { dispatch }
  ) => {
    let msg = '';
    try {
      if (withdrawAvailabilitySteps === WithdrawAvailability.ULX) {
        const { message } = await createWithdrawExplorerAsync({
          amount,
          userWalletId,
          emailCode,
          twoFACode
        });

        msg = message;
      } else {
        const { message } = await createWithdrawExplorerUSDTAsync({
          amount,
          userWalletId,
          emailCode,
          twoFACode
        });

        msg = message;
      }

      setAmount('');
      setStep(3);
      SuccessToast(msg);
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const createWithdrawPartner = createAsyncThunk(
  'createWithdrawPartner',
  async (
    {
      amount,
      userWalletId,
      setStep,
      emailCode,
      twoFACode,
      networkType,
      setAmount,
      networkCurrencyType,
      setLoadingCode
    }: {
      amount: number;
      userWalletId: number;
      setStep: Dispatch<SetStateAction<number>>;
      emailCode: string;
      twoFACode: string;
      networkType: NetworkType;
      setAmount: Dispatch<SetStateAction<string>>;
      networkCurrencyType: string;
      setLoadingCode: any;
    },
    { dispatch }
  ) => {
    try {
      setLoadingCode(true);
      const { message } = await createWithdrawPartnerAsync({
        amount,
        userWalletId,
        emailCode,
        twoFACode,
        networkType,
        networkCurrencyType
      });
      setAmount('');
      setStep(3);
      dispatch(changeAvailableBalance(amount));
      setLoadingCode(false);
      SuccessToast(message);
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  }
);

export const createWithdrawMLPPartner = createAsyncThunk(
  'createWithdrawMLPPartner',
  async (
    {
      amount,
      userWalletId,
      setStep,
      emailCode,
      twoFACode,
      networkType,
      setAmount,
      networkCurrencyType,
      setLoadingCode
    }: {
      amount: number;
      userWalletId: number;
      setStep: Dispatch<SetStateAction<number>>;
      emailCode: string;
      twoFACode: string;
      networkType: NetworkType;
      setAmount: Dispatch<SetStateAction<string>>;
      networkCurrencyType: string;
      setLoadingCode: any;
    },
    { dispatch }
  ) => {
    try {
      setLoadingCode(true);
      const { message } = await createWithdrawMLPPartnerAsync({
        amount,
        userWalletId,
        emailCode,
        twoFACode,
        networkType,
        networkCurrencyType
      });
      setAmount('');
      setStep(3);
      dispatch(changeAvailableMLPBalance(amount));
      setLoadingCode(false);
      SuccessToast(message);
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  }
);

export const createWithdrawFlipme = createAsyncThunk(
  'createWithdrawFlipme',
  async (
    {
      amount,
      setStep,
      networkType,
      setAmount,
      networkCurrencyType,
      setLoadingWithdraw
    }: {
      amount: number;
      setStep: Dispatch<SetStateAction<number>>;
      networkType: NetworkType;
      setAmount: Dispatch<SetStateAction<string>>;
      networkCurrencyType: string;
      setLoadingWithdraw: any;
    },
    { dispatch }
  ) => {
    try {
      setLoadingWithdraw(true);
      const { message } = await createWithdrawFlipmeAsync(
        amount,
        networkType,
        networkCurrencyType
      );

      setAmount('');
      setStep(3);
      dispatch(changeAvailableBalance(amount));
      setLoadingWithdraw(false);
      SuccessToast(message);
    } catch (error: any) {
      setLoadingWithdraw(false);
      ErrorToast(error.response.data.error);
    }
  }
);

export const createWithdrawEmailExplorerVerification = createAsyncThunk(
  'createWithdrawEmailExplorerVerification',
  async (
    { amount, userWalletId, verificationCode, setAmount }: any,
    { dispatch }
  ) => {
    try {
      const { message } = await createWithdrawExplorerVerificationEmailAsync({
        amount,
        userWalletId,
        verificationCode
      });

      dispatch(changeAvailableBalance(amount));
      setAmount('');
      SuccessToast(message);
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);
